import React, { useEffect } from "react";
import {
    Routes,
    Route,
    Navigate,
    useLocation,
    useNavigate,
} from "react-router-dom";
import Nav from "./Nav/Nav";
import Profile from "./Views/Profile/Profile";
import Dashboard from "./Views/Dashboard/Dashboard";
import Projects from "./Views/Projects/Projects";
import DesktopOnly from "./DesktopOnly/DesktopOnly";
import SupportButton from "./SupportButton/SupportButton";
import "./App.scss";

const App = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const { pathname } = location;

        if (
            pathname.startsWith("/dashboard/") &&
            !/^\/dashboard(\/edit\/[^/]+)?\/?$/.test(
                pathname
            )
        ) {
            navigate("/dashboard", { replace: true });
        } else if (
            pathname.startsWith("/projects/") &&
            !/^\/projects(\/edit\/[^/]+)?\/?$/.test(
                pathname
            )
        ) {
            navigate("/projects", { replace: true });
        } else if (
            pathname !== "/" &&
            !pathname.startsWith("/dashboard") &&
            !pathname.startsWith("/projects") &&
            !pathname.startsWith("/profile")
        ) {
            navigate("/", { replace: true });
        }
    }, [location, navigate]);

    return (
        <div className="App Shared">
            <Nav />
            <div className="content Views">
                <Routes>
                    <Route
                        path="/profile"
                        element={<Profile />}
                    />

                    <Route
                        path="/dashboard"
                        element={<Dashboard />}
                    />
                    <Route
                        path="/projects"
                        element={<Projects />}
                    />
                    <Route
                        path="/"
                        element={
                            <Navigate to="/dashboard" />
                        }
                    />
                    <Route
                        path="*"
                        element={
                            <Navigate to="/dashboard" />
                        }
                    />
                </Routes>
            </div>
            <SupportButton />
            <DesktopOnly />
        </div>
    );
};

export default App;
